import type {Token} from '../token'

declare module 'micromark-util-types' {
  interface TokenTypeMap {
    /**
     * `lineBreak` allows us to indicate where a line ending should be forced with a `<br>` tag instead of a newline.
     * We could just render `<br>` for every newline (like ProseMirror does), but that might have a performance cost.
     * So we only do it where necessary.
     */
    lineBreak: 'lineBreak'
  }
}

/**
 * The DOM will suppress the last line ending of a container, so users won't be able to type a trailing line ending.
 * This means they'd have to press enter twice on the last line to move to a new line. To work around this, we can make
 * the line break explicit by rendering a `br` element instead of a newline character. However, doing so for every line
 * ending would be expensive (from a perf perspective) so we just mark the last line ending for an explicit break.
 */
export function replaceFinalLineEndingWithBreak(tokens: Token[]) {
  // mutating instead of mapping to save memory with large token arrays
  const lastEnterToken = tokens.at(-2)
  const lastExitToken = tokens.at(-1)
  if (lastEnterToken?.type === 'lineEnding' && lastExitToken?.type === 'lineEnding') {
    lastEnterToken.type = 'lineBreak'
    lastExitToken.type = 'lineBreak'
  }
}
